import { RestMethod } from '../../_helpers/ApiConfig/RestMethod'
// import FilterResponse from '../../_helpers/FilterResponse'
// import toastr from 'toastr'

export const LogsService = {
    lastRecord,
    subModuleData
}

async function lastRecord(data) {
    try {
        const response = await RestMethod.POST('/change-log/last-record', data);
        return response.data;
    }
    catch (error) {
        console.log("error detected while fetching data from api");
        return null;
    }
}

async function subModuleData(data) {
    try {
        const response = await RestMethod.POST('/change-log/sub-module', data);
        return response.data;
    }
    catch (error) {
        console.log("error detected while fetching data from api");
        return null;
    }
}

